<template>
    <div class="auth-statement" v-if="loadingDone">
        <template v-if="promiseContent != ''">
            <div class="line"><img src="@assets/images/line.jpg" /></div>
            <div v-html="promiseContent" class="content" ref="contentDiv"></div>
            <div style='height:1.20rem;'></div>
            <div class='footer acea-row row-middle'>
                <button class='btn-submit' @click="onClickBtnOk" :disabled="isDisabled">{{ btnText }}</button>
            </div>
        </template>
        <template v-else>
            <div class="authorization-container">
                <div class="authorization-content">
                    <!-- 提示 -->
                    <div class="completion-message">
                        <div class="success-icon">{{ topIconTxt }}</div>
                        <p class="message-text">{{ topMsg }}</p>
                    </div>

                    <!-- 按钮区域 -->
                    <div class="button-group">
                        <button class="guarantee-btn" @click="onClickBtnPromise">查看授权承诺书</button>
                        <button class="credit-btn" @click="onClickBtnCredit">{{ btnCreditTxt }}</button>
                        <button class="credit-btn" @click="onClickBtnGuarantee">{{ btnGuaranteeTxt }}</button>
                    </div>
                    <div class="bottomTips" v-if="bottomTips != ''">{{ bottomTips }}</div>
                </div>
            </div>
        </template>
    </div>
</template>
<script>
import { mapGetters } from "vuex";
import { getCreditAuthStatement } from "@api/user";
import { VUE_APP_API_URL } from "@utils";

export default {
    name: "CreditAuth",
    components: {
    },
    props: {},
    data: function () {
        return {
            loadingDone: false,
            signInfoData: {},

            promiseContent: '',
            btnText: '数据加载中...',
            isDisabled: false,

            isCreditSigned: false,
            btnCreditTxt: '',
            isGuaranteeSigned: false,
            btnGuaranteeTxt: '',
            topMsg: '',
            topIconTxt: '',
            bottomTips: ''
        };
    },
    computed: mapGetters(["userInfo"]),
    mounted: function () {
        this.getCreditAuthStatement(0);
    },
    methods: {
        getCreditAuthStatement(toCreatePromise) {
            this.$dialog.loading.open("正在加载中");
            let that = this;
            getCreditAuthStatement({toCreatePromise: toCreatePromise}).then(res => {
                that.$dialog.loading.close();
                that.signInfoData = res.data;
                if (that.signInfoData.authPromiseContent == '') {
                    that.promiseContent = '';
                    that.isCreditSigned = that.signInfoData.creditSignStatus == 1;
                    that.isGuaranteeSigned = that.signInfoData.guaranteeSignStatus == 1;
                    that.btnCreditTxt = that.isCreditSigned ? '查看征信授权书' : '签署征信授权书';
                    that.btnGuaranteeTxt = that.isGuaranteeSigned ? '查看委托担保申请书' : '签署委托担保申请书';
                    if (that.isCreditSigned && that.isGuaranteeSigned) {
                        that.topMsg = '您已完成征信授权，我们会严格保密和合法合规使用您的个人隐私数据，也提示您保持良好信用记录！';
                        that.topIconTxt = '✓';
                        that.bottomTips = '';
                    } else {
                        that.topMsg = '为了完成征信授权，请认真仔细阅读并签署以下文件，我们致力于合法合规严格保护您的个人隐私数据！';
                        that.topIconTxt = '→';
                        that.bottomTips = '可能存在数据延迟，签署完如需查看文件请稍后刷新';
                    }
                } else {
                    that.promiseContent = that.signInfoData.authPromiseContent,
                    that.btnText = '至少还需阅读 10 秒';
                    that.runNum();
                }
                that.loadingDone = true;
            }).catch(err => {
                that.$dialog.loading.close();
                that.$dialog.error(err.msg || "数据加载失败");
                setTimeout(() => {
                    that.$router.go(-1);
                }, 2500);
            })

        },

        runNum() {
            let that = this;
            let n = 10;
            const run = setInterval(function () {
                n--;
                if (n == 0) {
                    clearInterval(run);
                    that.isDisabled = false;
                    that.btnText = '我已阅读并同意承诺';
                } else {
                    that.btnText = "至少还需阅读 " + n + " 秒";
                    that.isDisabled = true;
                }
            }, 1000);
        },

        onClickBtnPromise() {
            window.location.href = this.signInfoData.authPromiseUrl;
        },
        
        onClickBtnCredit() {
            let creditUrl = this.signInfoData.creditUrl;
            if(this.isCreditSigned) {
                window.location.href = creditUrl;
            } else {
                this.$router.push({ path: `/user/sign_credit_auth?contractUrl=${encodeURIComponent(creditUrl)}` });
            }
        },

        onClickBtnGuarantee() {
            let guaranteeUrl = this.signInfoData.guaranteeUrl;
            if(this.isCreditSigned) {
                window.location.href = guaranteeUrl;
            } else {
                this.$router.push({ path: `/user/sign_credit_auth?contractUrl=${encodeURIComponent(guaranteeUrl)}` });
            }
        },

        onClickBtnOk() {
            this.getCreditAuthStatement(1);
        }
    }
};
</script>

<style>
.auth-statement {
    width: 100%;
    overflow-x: hidden;
}

.auth-statement .content {
    padding: 0.1rem 0.3rem 1rem 0.3rem;
    background-color: #fff;
    width: 100%;
    height: 100%;
    overflow-x: hidden;
}

.auth-statement .footer {
  position: fixed;
  width: 100%;
  background-color: #f5f5f5;
  bottom: 0;
  height: 2rem;
  padding-bottom: 0.20rem;
  box-sizing: border-box;
}

.auth-statement .footer .btn-submit {
  width: 3.80rem;
  height: 0.76rem;
  border-radius: 0.50rem;
  text-align: center;
  line-height: 0.76rem;
  font-size: 0.30rem;
  color: #fff;
  margin: auto;
  background-color: #E93323;
}

.authorization-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #f5f5f5;
    padding: 20px;
    font-family: 'PingFang SC', 'Microsoft YaHei', sans-serif;
}

.authorization-content {
    background: white;
    border-radius: 12px;
    padding: 40px 30px 35px 30px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    max-width: 500px;
    width: 100%;
    text-align: center;
}

.completion-message {
    margin-bottom: 30px;
}

.success-icon {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #E93323;
    color: white;
    font-size: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0 auto 20px;
}

.message-text {
    font-size: 16px;
    line-height: 1.6;
    color: #333;
    margin: 0;
}

.button-group {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.guarantee-btn {
    background-color: #E93323;
    color: white;
    padding: 12px 24px;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.guarantee-btn:hover {
    background-color: #d42a1a;
    transform: translateY(-2px);
}

.credit-btn {
    background-color: transparent;
    color: #E93323;
    border: 2px solid #E93323 !important;
    padding: 10px 24px;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.3s ease;
    text-decoration: none;
    display: inline-block;
}

.credit-btn:hover {
    background-color: #fdf0ef;
    transform: translateY(-2px);
}

.bottomTips {
    font-size: 12px;
    color: gray;
    text-align: center;
    margin-top: 20px;
}


/* .auth-statement .footer .btn-submit .iconfont {
  font-size: 35r;
  margin-right: 8rpx;
  vertical-align: -1rpx;
} */
</style>
